<template>
   <div class="box">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>燕通营运系统</span>
      </div>
      <div class="text item">
      111111
      </div>
      <div class="text item">
      222222
      </div>      
    </el-card>    
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" >保 存</el-button>
      <el-button >取 消</el-button>
    </div>     
  </div>
</template>
<script>


export default {
  data() {
    return {
      title:"检测站欢迎您",
      carInfo:"",
      currentCar: "",
      currentInfo:{
          optType: "Station",
          optCode: "0",
      },
      qrImgSrc: "",
      user: null,
      UserCode: null,

      model: {
        TemplateCode: "0",
        TemplateName: "",
        SecretId: "",
        SecretKey: "",
        SmsSdkAppId: "",
        SignName: "",
        TemplateId: "",
        TemplateParamSet:"",
      },
      
      formLabelWidth: "150px",
    };
  },
  created() {

  },
  mounted() {

  },
  beforeDestroy() {

  },
  props: [],
  methods: {
 
  },
  components: {
      
  }
};
</script>

<style>
  .box{
      position:absolute;
      width:100%; 
      height:100%;  
      font-weight:bolder;    
  }

  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }
</style>


// WEBPACK FOOTER //
// src/components/rechargePay.vue